"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImThemeProviderZenith = ImThemeProviderZenith;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _imThemeContext = require("./imThemeContext");
var _themeZenith = require("../themeZenith");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ImThemeProviderZenith(props) {
  var children = props.children,
    _props$themeName = props.themeName,
    themeNameProp = _props$themeName === void 0 ? null : _props$themeName;
  var _useState = (0, _react.useState)(themeNameProp),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    name = _useState2[0],
    setName = _useState2[1];
  var value = (0, _react.useMemo)(function () {
    var themeName = name || 'im-light';
    var setThemeName = function setThemeName(value) {
      setName(value);
    };
    var theme = createThemeFromName(themeName);
    var result = {
      isZenith: true,
      setThemeName: setThemeName,
      theme: theme,
      themeName: themeName
    };
    return result;
  }, [name, setName]);
  if (!value) {
    return null;
  }
  var Provider = _imThemeContext.imThemeContext.Provider;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
}
function createThemeFromName(themeName) {
  return (0, _styles.createTheme)(getThemeOptionsFromName(themeName));
}
function getThemeOptionsFromName(themeName) {
  switch (themeName) {
    case 'im-light':
      return (0, _themeZenith.createImThemeOptionsZenith)('light');
    case 'im-dark':
      return (0, _themeZenith.createImThemeOptionsZenith)('dark');
    case 'mui-light':
    case 'mui-dark':
      return {};
  }
}